var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus-lg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus (Stroke)",
    d: "M6.99996 0.142578C7.47335 0.142578 7.85711 0.526334 7.85711 0.999721V6.14258H13C13.4734 6.14258 13.8571 6.52633 13.8571 6.99972C13.8571 7.47311 13.4734 7.85686 13 7.85686H7.85711V12.9997C7.85711 13.4731 7.47335 13.8569 6.99996 13.8569C6.52658 13.8569 6.14282 13.4731 6.14282 12.9997V7.85686H0.999965C0.526578 7.85686 0.142822 7.47311 0.142822 6.99972C0.142822 6.52633 0.526578 6.14258 0.999965 6.14258H6.14282V0.999721C6.14282 0.526334 6.52658 0.142578 6.99996 0.142578Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLg);
export default __webpack_public_path__ + "static/media/plus-lg.de7a6f297990805b89109cae7abdc5e5.svg";
export { ForwardRef as ReactComponent };